import { type ClassValue, clsx } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatDateTime(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function generateInstanceId(
  meetingTypeName: string,
  level: string,
  date: string
): string {
  const prefix = meetingTypeName.substring(0, 3).toUpperCase();
  const levelCode = level[0];
  const dateStr = date.replace(/-/g, '');
  const timestamp = Date.now();
  
  return `${prefix}-${levelCode}-${dateStr}-${timestamp}`;
}

export function escapeSQLString(str: string): string {
  return str.replace(/'/g, "''");
}
